import styled, { css } from 'styled-components';

import Cost from '@r1-frontend/ui-react/components/costs/Cost';
import { TCostProps } from '@r1-frontend/ui-react/components/costs/Cost/Cost';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const StyledOldCost = styled(Cost)<TCostProps & { $color?: COLORS }>`
    ${({ $color = 'inherit' }) => css`
        color: ${$color};
        text-decoration-color: ${$color};
    `}
    text-decoration: line-through;
`;
